/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import { Link } from "react-router-dom";
import { Visibility } from "@mui/icons-material";
import { withRouter } from "react-router";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { Card } from "@mui/material";
import Button from "@mui/material/Button";
import moment from "moment";
import { InfinitySpin } from "react-loader-spinner";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
class Posist extends React.Component {
  constructor(props) {
    super(props);
    //  console.log(props)
    this.state = {
      items: [],
      DataisLoaded: false,
      restaurent: [],
      restaurent_outlet: [],
      loading: false,
      products: "",
      setProducts: "",
      allProducts: "",
      setAllProducts: "",
      // startDate: new Date(),
      setStartDate: new Date(),
      // endDate: new Date(),
      setEndDate: new Date(),
      selectionRange: {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },

      restro_id: "",
      start_date: "",
      rest: "",
      end_date: "",
      type: "",
      currentPage: 1,
      totalPages: 1,
      total: 0,
      totalposist: 0,
      per_page: 10,
      page: 1,
      booking_status: "",
      booking_type: "",
      bill_order: "",
      amount_order: "",
    };
  }

  componentDidMount() {
    this.fetchPosistData(this.state.page, this.state.per_page);
    this.fetchRestData();
    this.fetchOutletData();
  }

  fetchPosistData(
    page,
    per_page,
    start_date,
    end_date,
    bill_order,
    amount_order,
    rest
  ) {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let restro_id = b.restro_id;
    if (rest) {
      restro_id = rest;
    }

    axios
      .post(endpoints.getPosistData, {
        restro_id,
        page,
        per_page,
        start_date,
        end_date,
        bill_order,
        amount_order,
      })
      .then((response) => {
        // console.log("response", response);
        this.setState({
          items: response.data.data,
          totalposist: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        // Optionally set DataisLoaded to true to stop the loader if there's an error
        this.setState({ DataisLoaded: true });
      });
  }

  posistFilter = () => {
    if (
      !this.start_date &&
      !this.end_date &&
      !this.bill_order &&
      !this.amount_order &&
      !this.rest
    ) {
      alert("Please Select Any Filter");
      return;
    }
    this.setState({ page: 1, per_page: 10 }, () => {
      this.fetchPosistData(
        this.state.page,
        this.state.per_page,
        this.start_date,
        this.end_date,
        this.bill_order,
        this.amount_order,
        this.rest
      );
    });
  };

  fetchRestData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    axios.post(endpoints.getRestaurentsDropDownPosist, {}).then((response) => {
      // window.location.reload(true);
      //console.log("response", response);
      this.setState({
        restaurent: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
      // console.log(response.data);
    });
  }

  fetchOutletData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    // console.log(restro_id)
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    axios
      .post(endpoints.getOutlet, {
        restro_id,
        user_id,
        page,
        per_page,
      })
      .then((response) => {
        // window.location.reload(true);
        // console.log("response", response);
        this.setState({
          restaurent_outlet: response.data.data,
          total: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
        // console.log('outlet ', response.data);
      });
  }

  handlePageChange = (page) => {
    this.fetchPosistData(
      page,
      this.state.per_page,
      this.start_date,
      this.end_date,
      this.bill_order,
      this.amount_order,
      this.rest
    );
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ per_page: newPerPage }, () => {
      this.fetchPosistData(
        page,
        newPerPage,
        this.start_date,
        this.end_date,
        this.bill_order,
        this.amount_order,
        this.rest
      );
    });
  };

  whatsApp = () => {
    const { restro_id } = this.state;
    this.setState({ loading: true });

    axios
      .post(endpoints.whatsApp, { restro_id })
      .then((response) => {
        this.setState({ loading: false });
        // Show toaster upon successful response
        toast.success("Data saved successfully!");
      })
      .catch((error) => {
        console.error("Error updating dish order:", error);
        // Set loading state to false in case of an error
        this.setState({ loading: false });
        // Show error toaster
        toast.error("Error saving data!");
      });
  };

  render() {
    const { DataisLoaded, loading } = this.state;
    const a = this.state.items;

    const b = this.state.total;

    const links = this.state.restaurent;
    const outlets = this.state.restaurent_outlet;
    const user = localStorage.getItem("user");
    const user_data = JSON.parse(user);
    this.restro_id = user_data.restro_id;
    // console.log(outlets)

    // const b = JSON.stringify(a)
    const dates = new Date();
    const month = JSON.stringify(dates.getMonth() + 1);
    const date = JSON.stringify(dates.getDate());
    const year = JSON.stringify(dates.getFullYear());
    const recent_date = month + "-" + date;

    // console.log(a, "items")

    const columns = [
      {
        selector: (row) => row.name,
        cellExport: (row) => row.name,
        sortable: true,
      },
      {
        selector: (row) => row.mobile,
        cellExport: (row) => row.mobile,
        sortable: true,
      },
      {
        selector: (row) => row.tot,
        cellExport: (row) => row.tot,
        sortable: true,
      },

      {
        selector: (row) => row.resturent_name,
        cellExport: (row) => row.resturent_name,
        sortable: true,
      },

      {
        selector: (row) =>
          moment(new Date(row.settled_at)).format("YYYY-MM-DD") ===
          "Invalid date"
            ? "SETTLED AT"
            : moment(new Date(row.settled_at)).format("YYYY-MM-DD"),
        cellExport: (row) =>
          moment(new Date(row.settled_at)).format("YYYY-MM-DD") ===
          "Invalid date"
            ? "SETTLED AT"
            : moment(new Date(row.settled_at)).format("YYYY-MM-DD"),

        sortable: true,
      },

      {
        selector: (row) =>
          row.booking_status === "ACTION" ? (
            "ACTION"
          ) : (
            <div>
              <Link to={`/dashboard/posist_detail/${row.restro_id}/${row.id}`}>
                {" "}
                <Visibility />{" "}
              </Link>
            </div>
          ),
        cellExport: (row) => "",

        // cellExport: (row) => row.booking_status,
        sortable: true,
      },
    ];

    const posist = async (rest) => {
      if (!rest) {
        alert("Please Select Restaurant");
        return;
      }
      var url = "https://ngapi.firstfiddle.in/api/admin/";
      // var url = 'http://localhost:8080/api/admin/'

      if (rest === "1") {
        url += "update_freshsale_bill_bougie";
      } else if (rest === "2") {
        url += "update_freshsale_bill_miso";
      } else if (rest === "5") {
        url += "update_freshsale_bill_diablo";
      } else if (rest === "28") {
        url += "update_freshsale_bill_plum";
      } else if (rest === "55") {
        url += "update_freshsale_bill_tp";
      } else if (rest === "10") {
        url += "update_freshsale_bill_dragonfly";
      } else if (rest === "13") {
        url += "update_freshsale_bill_lotd";
      } else if (rest === "15") {
        url += "update_freshsale_bill_openhouse";
      } else if (rest === "16") {
        url += "update_freshsale_bill_warehouse";
      } else if (rest === "17") {
        url += "update_freshsale_bill_wolf";
      } else if (rest === "85") {
        url += "update_freshsale_bill_bizou";
      } else if (rest === "91") {
        url += "update_freshsale_bill_diablocyberhub";
      } else if (rest === "93") {
        url += "update_freshsale_bill_thanks";
      } else if (rest === "110") {
        url += "update_freshsale_bill_diablo_chd";
      } else if (rest === "118") {
        url += "update_freshsale_bill_m3m";
      }

      await axios.get(url, {}).then(
        (response) => {
          alert(response.data[0].res_data.message);
          //   console.log(response.data[0].res_data.message)
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
    };

    const onWhatsappChange = (e) => {
      this.restro_id = e.target.value;
    };

    const whatsApp = async (restro_id) => {
      if (!this.restro_id) {
        alert("Please Select Restaurant");
        return;
      }
      var restro_id = this.restro_id;
      this.setState({ loading: true });

      axios
        .post(endpoints.whatsApp, { restro_id })
        .then((response) => {
          this.setState({ loading: false });
          // Show toaster upon successful response
          toast.success("Data saved successfully!");
        })
        .catch((error) => {
          console.error("Error updating dish order:", error);
          // Set loading state to false in case of an error
          this.setState({ loading: false });
          // Show error toaster
          toast.error("Error saving data!");
        });
    };

    const billorderChange = (e) => {
      this.bill_order = e.target.value;
    };

    const amountorderChange = (e) => {
      this.amount_order = e.target.value;
    };

    const onRestChange = (e) => {
      this.rest = e.target.value;
    };
    const c = [
      {
        name: "NAME",
        mobile: "NUMBER",
        resturent_name: "RESTAURANT",
        tot: "TOTAL AMOUNT",
        booking_status: "ACTION",
        settled_at: "SETTLED AT",
      },
    ];

    const data = c.concat(a);
    const tableData = {
      columns,
      data,
    };

    this.handleSelect = (ranges) => {
      this.setState({
        selectionRange: {
          startDate: ranges.selection.startDate,
          endDate: ranges.selection.endDate,
          key: "selection",
        },
      });
      this.start_date = moment(new Date(ranges.selection.startDate)).format(
        "YYYY-MM-DD"
      );
      this.end_date = moment(new Date(ranges.selection.endDate)).format(
        "YYYY-MM-DD"
      );
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>Posist</h2>
        <Card className="px-3 py-3">
          <form className="ui form" encType="multipart/form-data">
            <div className="row">
              <DateRangePicker
                ranges={[this.state.selectionRange]}
                onChange={this.handleSelect}
                className="col-md-5"
              />

              <div className="col-md-2">
                <label>Order By Bill</label>
                <select
                  name="bill_order"
                  required
                  className="form-control"
                  onChange={(e) => billorderChange(e)}
                >
                  <option value="0">Select</option>
                  <option value="ASC">Asscending</option>
                  <option value="DESC">Decending</option>
                </select>
              </div>

              <div className="col-md-2">
                <label>Order By Amount</label>
                <select
                  name="amount_order"
                  required
                  className="form-control"
                  onChange={(e) => amountorderChange(e)}
                >
                  <option value="0">Select</option>
                  <option value="ASC">Asscending</option>
                  <option value="DESC">Decending</option>
                </select>
              </div>

              {this.restro_id === 0 ? (
                <div className="col-md-2">
                  <label>Restaurant</label>
                  <select
                    name="rest"
                    required
                    className="form-control"
                    onChange={(e) => onRestChange(e)}
                  >
                    <option value="0">Select Restaurant</option>
                    {links.map((e, key) => {
                      return (
                        <option key={key} value={e.id}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : (
                ""
              )}
              <div className="col col-1">
                <div className="mt-5 text-center">
                  <Button
                    className="w-50"
                    onClick={this.posistFilter}
                    style={{ color: "white" }}
                    variant="contained"
                    size="medium"
                  >
                    Filter
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Card>
        <br></br>
        <br></br>

        <h2>Fetch And Update Data</h2>
        <Card className="px-3 py-3">
          {this.restro_id === 0 ? (
            <div className="row">
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-6">
                    <select
                      name="rest"
                      required
                      className="form-control"
                      onChange={(e) => onRestChange(e)}
                    >
                      <option value="0">Select Restaurant</option>
                      {links.map((e, key) => {
                        return (
                          <option key={key} value={e.id}>
                            {e.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <Button
                      className=""
                      startIcon={<SaveIcon />}
                      onClick={() => posist(this.rest)}
                      style={{ color: "white" }}
                      variant="contained"
                      size="medium"
                    >
                      {/* Get Posist Data And Update in Freshsale */}
                      Update in Freshsale
                    </Button>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-6">
                    <select
                      name="restro_id"
                      required
                      className="form-control"
                      style={{ fontSize: "14px" }}
                      onChange={(e) => onWhatsappChange(e)}
                      // onChange={(e) => this.setState({ restro_id: e.target.value })}
                    >
                      <option value="0">Select Restaurant</option>
                      <option value="1">Mi-Piaci</option>
                      <option value="2">Misosexy</option>
                      <option value="5">Diablo</option>
                      <option value="10">Dragonfly</option>
                      <option value="55">Lotd Saket</option>
                      <option value="85">Bizou-Bizou</option>
                      <option value="28">Plum Coffee and Cocktails</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <LoadingButton
                      type="submit"
                      onClick={() => whatsApp(this.restro_id)}
                      // onClick={this.whatsApp}
                      loading={loading}
                      loadingPosition="start"
                      startIcon={<SaveIcon />}
                      variant="contained"
                      size="large"
                    >
                      Save
                    </LoadingButton>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            // <div className="">
            //   <div className="col-md-4">
            //     <Button

            //       startIcon={<SaveIcon />}
            //       onClick={() => posist(this.restro_id)}
            //       style={{ color: "white" }}
            //       variant="contained"
            //       size="medium"
            //     >
            //     Update in Freshsale
            //     </Button>

            //   </div>
            //   <div className="col-md-4">
            //   <LoadingButton
            //       type="submit"
            //       onClick={() => whatsApp(this.restro_id)}
            //       // onClick={this.whatsApp}
            //        loading={loading}
            //        loadingPosition="start"
            //        startIcon={<SaveIcon />}
            //       variant="contained"
            //       size="medium"

            //     >
            //        Whatsapp Feedback Send
            //     </LoadingButton>

            // </div>
            // </div>
            <div
              className="button-container"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "50%",
              }}
            >
              <div style={{ flex: "1", marginRight: "10px" }}>
                <Button
                  startIcon={<SaveIcon />}
                  onClick={() => posist(this.restro_id)}
                  style={{ color: "white", width: "100%" }}
                  variant="contained"
                  size="medium"
                >
                  Update in Freshsale
                </Button>
              </div>
              <div style={{ flex: "1", marginLeft: "10px" }}>
                <LoadingButton
                  type="submit"
                  onClick={() => whatsApp(this.restro_id)}
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="medium"
                  style={{ width: "100%" }}
                >
                  Whatsapp Feedback Send
                </LoadingButton>
              </div>
            </div>
          )}
        </Card>

        <div className="row mt-2">
          <DataTableExtensions {...tableData} filter={false}>
            <DataTable
              defaultSortField="id"
              pagination
              paginationServer
              paginationTotalRows={this.state.totalposist}
              onChangePage={this.handlePageChange}
              onChangeRowsPerPage={this.handlePerRowsChange}
              progressPending={!this.state.DataisLoaded}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default withRouter(Posist);
